(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8719],{

/***/ 67398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BsClock; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BsClock(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
      }
    }, {
      "tag": "path",
      "attr": {
        "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 64108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ HKTradingGuide; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/action-function/scrollToElement.js
var scrollToElement = __webpack_require__(97974);
// EXTERNAL MODULE: ./common/functions.js
var functions = __webpack_require__(98989);
// EXTERNAL MODULE: ./components/atoms/ButtonNew/index.js
var ButtonNew = __webpack_require__(30852);
// EXTERNAL MODULE: ./components/atoms/Icon/bs/BsClock.js
var BsClock = __webpack_require__(67398);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/FormDowload/index.js
var FormDowload = __webpack_require__(73765);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/WhatMakeUsDifferentV3.js + 2 modules
var WhatMakeUsDifferentV3 = __webpack_require__(97542);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/hk/guide-and-tool/hong-kong-trading-guide/index.js















var HongKongTradingGuide = function HongKongTradingGuide(_ref) {
  var _firstPost$featuredIm;

  var data = _ref.data,
      posts = _ref.posts;

  var _useState = (0,react.useState)(false),
      showAll = _useState[0],
      setShowAll = _useState[1];

  var firstPost = posts[1] || {};
  var listPost = posts.length > 1 ? posts.filter(function (item, index) {
    return index !== 1 && index < 8;
  }) : [];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "min-h-auto",
      bannerCustom: {
        style: {
          minHeight: "605px"
        }
      },
      title: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: "mb-4 text-center text-bbc-40px font-semibold text-bbc-brand-600 lg:mb-2 lg:text-left lg:text-bbc-48px",
        dangerouslySetInnerHTML: {
          __html: data.banner.title
        }
      }),
      description: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-4 text-center lg:mb-6 lg:text-left",
        dangerouslySetInnerHTML: {
          __html: data.banner.description
        }
      }),
      leftClassName: "col-12 lg:col-7",
      rightClassName: "col-12 lg:col-5",
      tag: data.banner.tag,
      breadcrumbs: data.banner.breadcrumbs,
      bgColor: "bg-bbc-gradient-8 lg:bg-bbc-gradient-hk-ecommerce",
      leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-6 text-center lg:mb-0 lg:text-left",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonNew/* default */.Z, {
          href: "#".concat(data.dataFormDownload.id),
          as: "a",
          className: "",
          onClick: function onClick(e) {
            (0,scrollToElement/* default */.Z)(e, false);
          },
          children: "Download Now"
        })
      }),
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        wrapper: {
          className: "bbc-banner-image-country xl:top-12"
        },
        src: data.banner.image,
        width: 540,
        height: 540,
        priority: true,
        alt: "banner-img"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mt-10 lg:mt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "With this guide, you'll be able to:",
          className: "title-h2 mb-6 text-center text-bbc-brand-800 lg:mb-10 lg:text-bbc-brand-700"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferentV3/* WhatMakeUsDifferentV3 */.N, {
          title: data.whatMakeUsDifferentTitle,
          data: data.dataWhatMakeUsDifferent,
          ebookImage: data.ebookImage,
          customSlider: {
            style: {
              height: 480
            }
          },
          customSliderSlide: {
            style: {
              height: 480
            }
          },
          className: "bg-transparent"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Explore Latest Resources",
          className: "title-h2 mb-6 text-center text-bbc-brand-700"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-6 text-center lg:mb-10",
          children: "Get access to concise and up-to-date information about Hong Kong trade market"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-8",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "overflow-hidden rounded-[20px] bg-bbc-neutral-200 hover:shadow-[0px_0px_20px_rgba(124,120,120,0.2)]",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                image: firstPost === null || firstPost === void 0 ? void 0 : (_firstPost$featuredIm = firstPost.featuredImage) === null || _firstPost$featuredIm === void 0 ? void 0 : _firstPost$featuredIm.node
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "p-6 lg:px-10 lg:pb-10 lg:pt-8",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  className: "text-lg font-semibold text-bbc-brand-900 lg:text-bbc-30px",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                    href: firstPost === null || firstPost === void 0 ? void 0 : firstPost.uri,
                    children: firstPost === null || firstPost === void 0 ? void 0 : firstPost.title
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "mt-3 inline-flex items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BsClock/* BsClock */.Z, {
                    size: 18
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "inline-block pl-2 text-sm",
                    children: (0,functions/* formatDate */.p)(firstPost === null || firstPost === void 0 ? void 0 : firstPost.date)
                  })]
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row mt-6 gap-y-3 lg:mt-0",
              children: [listPost.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-12 ".concat(index > 4 && !showAll ? "hidden" : ""),
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "p-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                      as: "h3",
                      className: "text-lg font-medium line-clamp-3",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                        href: item === null || item === void 0 ? void 0 : item.uri,
                        children: item === null || item === void 0 ? void 0 : item.title
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mt-3 inline-flex items-center",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BsClock/* BsClock */.Z, {
                        size: 18
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "inline-block pl-2 text-sm",
                        children: (0,functions/* formatDate */.p)(item === null || item === void 0 ? void 0 : item.date)
                      })]
                    })]
                  })
                }, index);
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "col-12 text-center lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  onClick: function onClick() {
                    return setShowAll(true);
                  },
                  className: "p-2 font-semibold text-bbc-brand-500 ".concat(showAll ? "hidden" : ""),
                  children: "Read more"
                })
              })]
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      id: data.dataFormDownload.id,
      className: "bg-bbc-gradient-service py-10 lg:py-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormDowload/* default */.Z, {
          title: data.dataFormDownload.title || "",
          description: data.dataFormDownload.description || "",
          checkboxText: data.dataFormDownload.checkboxText || "",
          checkboxTextClassName: data.dataFormDownload.checkboxTextClassName || "",
          apiLink: data.dataFormDownload.form.apiLink,
          contactFromId: data.dataFormDownload.form.contactFromId,
          countryId: data.dataFormDownload.form.countryId
        })
      })
    })]
  });
};

/* harmony default export */ var hong_kong_trading_guide = (HongKongTradingGuide);
;// CONCATENATED MODULE: ./pages/hk/guide-and-tool/hong-kong-trading-guide/data.json
var data_namespaceObject = JSON.parse('{"banner":{"title":"Hong Kong Offshore Company For Overseas Trade","description":"Get cursory insights on what it\'s like to start a Hong Kong offshore company for your overseas trade operation - including benefits, tax exemption, and more.","tag":"Free download","image":"/assets/images/hk/guide-and-tool/hong-kong-trading-guide/banner-hk-trading.png","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Guide & Tool","uri":"/guide-and-tool"},{"title":"Hong Kong Offshore Trade Company"}]},"ebookImage":{"src":"/assets/images/hk/guide-and-tool/hong-kong-trading-guide/ebook-hk-trading.png","width":540,"height":540},"dataWhatMakeUsDifferent":[{"title":"Incorporation","description":"Step-by-step guide to start an offshore company in Hong Kong","listWithIcon":["Key requirements and restrictions for business names, structures, ownership, and more","Procedures for filing application to register offshore company"]},{"title":"Taxation","description":"Overview of Hong Kong offshore tax exemption","listWithIcon":["Who can be qualified for offshore tax exemption","How to apply for tax exemption in Hong Kong"]},{"title":"Banking","description":"Gain a clear understanding of all the issues related to business banking in Hong Kong:","listWithIcon":["Top 3 banks for offshore company in Hong Kong","Alternative options for traditional banks"]}],"dataFormDownload":{"id":"hong-kong-trading-guide","title":"Our Guide Take You To Success And Beyond","description":"Fill out the form and discover why an offshore company is the best structure for your overseas trade operation.","form":{"apiLink":"api/portal/contact_form/trading_guide","countryId":98,"triggerName":"RMD - Hong Kong Trading Guide","contactFromId":43}}}');
;// CONCATENATED MODULE: ./pages/hk/guide-and-tool/hong-kong-trading-guide/index.js




var __N_SSG = true;
function HKTradingGuide(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "hk",
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(hong_kong_trading_guide, {
      data: data_namespaceObject,
      posts: data.posts
    })
  });
}

/***/ }),

/***/ 71401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk/guide-and-tool/hong-kong-trading-guide",
      function () {
        return __webpack_require__(64108);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,9413,4090,9738,7447,7720,2888,179], function() { return __webpack_exec__(71401); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);